<template>
  <div v-if="financial !== null">
    <!-- Title -->
    <div class="block mb-5 mb-5">
      <label class="pa-5 d-flex">
        <div class="w-240px mr-5">
          <h4>Title</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="financial.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
    </div>
    <!-- Sections Block -->
    <div class="block" style="margin-bottom: 30px;">
      <PageMenu :sections="sections">
        <component :is="sectionView" :financial="financial"></component>
      </PageMenu>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import PageMenu from '@/components/PageMenu.vue';

import EditMonthReport from '@/views/I_IR/c/I-0-4-1-2-1__IR-Financial Information_edit-month-report.vue';
import EditSeasonReport from '@/views/I_IR/c/I-0-4-1-2-2__IR-Financial Information_edit-season-report.vue';
import EditFinancialReport from '@/views/I_IR/c/I-0-4-1-2-3__IR-Financial Information_edit-financial-report.vue';
import EditYearReport from '@/views/I_IR/c/I-0-4-1-2-4__IR-Financial Information_edit-year-report.vue';

export default {
  components: {
    Breadscrumbs,
    PageMenu,
    EditMonthReport,
    EditSeasonReport,
    EditFinancialReport,
    EditYearReport,
  },
  data: () => ({
    sections: [
      {
        name: '每月營收報告',
        component: 'EditMonthReport',
      },
      {
        name: '每季營運報告',
        component: 'EditSeasonReport',
      },
      {
        name: '財務報告書',
        component: 'EditFinancialReport',
      },
      {
        name: '公司年報',
        component: 'EditYearReport',
      },
    ],
  }),
  computed: {
    ...mapState('financial', ['financial']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },
  methods: {
    editHandler() {
      this.$router.push({
        path: '/investor-relations/edit',
        query: {
          section: this.$route.query.section,
        },
      });
    },
  },
};
</script>

<style></style>
